import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

interface ICheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  checked?: boolean
  onChangeHandler: (e: boolean) => void
}

const StyledCheckbox = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;

  label {
    display: flex;
    height: 30px;
    align-items: center;
  }

  input[type='checkbox'] {
    -webkit-appearance: none;
    appearance: none;

    background-color: rgba(51, 61, 108, 0.06);
    border: 2px solid rgba(51, 61, 108, 0.08);

    width: 20px;
    height: 20px;
    border-radius: 4px;
    margin-right: 26px;
    outline: none;
    cursor: pointer;

    &:checked {
      position: relative;
      background-color: rgba(51, 61, 108, 0.06);

      &:before {
        content: '✔';
        background-color: transparent;
        color: rgba(51, 61, 108, 0.5);
        position: absolute;
        font-size: 16px;
        font-size: 20px;
        right: -1px;
        top: -5px;
      }
    }
  }
`

const Checkbox: React.FunctionComponent<ICheckboxProps> = ({
  label,
  checked,
  onChangeHandler,
  ...props
}: ICheckboxProps) => {
  const handleInputChange = (e: any) => {
    onChangeHandler(e.target.checked)
  }
  // const [isChecked, setIsChecked] = useState(checked)

  return (
    <StyledCheckbox {...props}>
      <label>
        <input type='checkbox' checked={checked} onChange={handleInputChange} />
        <span>{label}</span>
      </label>
    </StyledCheckbox>
  )
}

export default Checkbox
